function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { immerAction as immerAction$1 } from './immerAction.js';

function wrapActions(store, actions) {
  var wrappedActions = {};
  Object.keys(actions).forEach(function (key) {
    if (typeof actions[key] === "function") {
      var originalFunction = actions[key];
      actions[key] = immerAction$1(store, originalFunction);
    }

    if (_typeof(actions[key]) === "object") {
      wrappedActions[key] = wrapActions(store, actions[key]);
    }
  });
  return wrappedActions;
}

export { wrapActions };